<template src="./App.html"></template>

<script>
import { mapActions, mapState } from 'vuex'
import PurchasePage from '@/views/PurchasePage'

export default {
  components: {
    PurchasePage,
  },
  data() {
    return {
      // Hint: this has to be defined including the bonus shop slider,
      // otherwise element is removed before real state can be evaluated!
      tabs: [
        'address',
        'payment',
        'shipping',
        'bonus_shop_slider',
        'overview',
      ],
    }
  },
  computed: {
    customer() {
      return process.env.customer
    },
    ...mapState('translations', ['pendingTranslations']),
    ...mapState('settings', ['settings']),
  },
  async created() {
    if (this.customer === 'junior') {
      this.tabs = [
        'email',
        'address',
        'payment',
        'shipping',
        'overview',
      ]
    } else {
      await this.getSettings().then(_ => {
        if (this.settings?.active_features?.bonus_program || this.customer === 'bueffelbill') {
          this.tabs = [
            'address',
            'payment',
            'shipping',
            'bonus_shop_slider',
            'overview',
          ]
        } else {
          this.tabs = [
            'address',
            'payment',
            'shipping',
            'overview',
          ]
        }
      })
    }
  },
  methods: {
    ...mapActions('settings', ['getSettings']),
  },
}
</script>
